import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
  Paper,
  Divider,
} from '@mui/material';
import { getPgtOrders } from './pgtOrder.helper';
import { usePatientContext } from '../patinetProvider';
import { capitalizeTitle } from '../../utils/commonUtils';

export default function PgtOrders() {
  const theme = useTheme();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [orders, setOrders] = useState<any[]>([]);
  
  const { patientId } = usePatientContext();

  useEffect(() => {
    if (patientId) {
      getPgtOrders(patientId, 'PROGENESIS').then((response) => {
        setOrders(response.objects || []);
      });
    }
  }, [patientId]);

  return (
    <Card sx={{ p: 1, boxShadow: 'none', border: 'none' }}>
      <Divider sx={{ mb: 2, borderColor: theme.palette.divider }} />
      <CardContent sx={{ p: 0 }}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            boxShadow: 'none',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            overflowX: 'auto',
          }}
        >
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  'Embryo No.',
                  'Date & Time',
                  'Day',
                  'Stage',
                  'Grade',
                  'Incubator',
                  'PGT Type',
                  'Facility',
                  'Plan',
                  'Witness',
                  'Embryologist',
                ].map((header, idx) => (
                  <TableCell
                    key={idx}
                    sx={{
                      backgroundColor: '#f5f5f5',
                      fontWeight: 600,
                      fontSize: '0.88rem',
                      color: '#333',
                      whiteSpace: 'nowrap',
                      padding: '10px 16px',
                      borderBottom: '1px solid #ccc',
                      lineHeight: 2.5,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {orders.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={11} align="center">
                    No PGT Orders found.
                  </TableCell>
                </TableRow>
              ) : (
                orders.map((item, index) => (
                  <TableRow
                    key={index}
                    hover
                    sx={{
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        backgroundColor: theme.palette.action.selected,
                        transform: 'scale(1.005)',
                        boxShadow: `0 2px 4px ${theme.palette.action.hover}`,
                      },
                      '& td': {
                        fontSize: '0.85rem',
                        padding: '10px 16px',
                        lineHeight: 2.5,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                      },
                    }}
                  >
                    <TableCell>{item.embryo_no}</TableCell>
                    <TableCell>
                      {item.pgt_order?.pgt_order_date || '-'} |{' '}
                      {item.pgt_order?.pgt_order_time || '-'}
                    </TableCell>
                    <TableCell>{item.day ?? '-'}</TableCell>
                    <TableCell>{item.stage ?? '-'}</TableCell>
                    <TableCell>{item.grade ?? '-'}</TableCell>
                    <TableCell>{item.incubator ?? '-'}</TableCell>
                    <TableCell>{item.pgt_order?.pgt_type ?? '-'}</TableCell>
                    <TableCell>{item.pgt_order?.pgt_facility ?? '-'}</TableCell>
                    <TableCell>{capitalizeTitle(item.action) ?? '-'}</TableCell>
                    <TableCell>{item.witness ?? '-'}</TableCell>
                    <TableCell>{item.embryologist ?? '-'}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
